import React from 'react';
import ButtonComp from 'components/button';
import './style.scss';

export default function ConfirmationVMAccessPopup(props) {
    const { closeModalPopup,handleLabVmAccess } = props;
    return (
        <>
            <div className='popup-container'>
                <div className='header-container'>
                    <div className='heading'>Confirmation</div>
                    <div className='close-icon' onClick={closeModalPopup}>
                        <i className="cross-icon fa fa-times-circle" aria-hidden="true" ></i>
                    </div>
                </div>

                <div className='content-container'>You have excluded all the VM's. We recommend to include atleast one VM. If you click on "Yes", lab will be created without VM. still want to continue..? </div>
                <div className='footer-container'>
                    <ButtonComp label={'Yes'} handleClick={handleLabVmAccess}/>
                    <ButtonComp label={'No'} handleClick={closeModalPopup} />
                </div>

            </div>
        </>
    )
}